import React, {useState} from 'react'
import Box from '@material-ui/core/Box'
import { BlueButton } from '../Components/Buttons'
import { useParams } from "react-router-dom"
import queryString from 'query-string'
import Styles from '../Styles/Styles'
import OverlayLoader from "../Components/OverlayLoader";
import Wrapper from "../Components/Wrapper";

function Found() {
    const classes = Styles({});
    const [isLoading, setIsLoading] = useState(false);
    let { params } = useParams();
    const parsed = queryString.parse(params);
    const companyUrl = parsed.url;

    const handleSubmit = (event:any) => {
        setIsLoading(true);
        window.location.href = 'https://'+ companyUrl
    }

    return (
        <>
            <Wrapper>
                <Box className={classes.logoContainer}>
                    <img width="140" alt="ISN" src={process.env.REACT_APP_ISN_LOGO} />
                </Box>
                <p className={classes.infoCenter}>Your company key is:</p>
                <p className={classes.companyName}>{parsed.ck}</p>
                <Box className={classes.inputBox} style={{paddingTop: 10}} >
                    <BlueButton
                        onClick={handleSubmit}
                        fullWidth
                        className={classes.button}
                    >
                        Go to my ISN
                    </BlueButton>
                </Box>
            </Wrapper>
            <OverlayLoader open={isLoading} thickness={5} size={50}/>
        </>
    );
};

export default Found